import { useState } from 'react';
import { Link } from 'react-router-dom';
import Button from '../base/Button';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');

  return (
    <header className="bg-white shadow-sm border-b">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <h1 className="text-2xl font-bold text-orange-500" style={{ fontFamily: '"Pacifico", serif' }}>
              会找我
            </h1>
          </Link>

          {/* Search Bar */}
          <div className="flex-1 max-w-lg mx-8">
            <div className="relative">
              
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              </div>
            </div>
          </div>

          {/* Navigation & Actions */}
          <div className="flex items-center space-x-4">
            <Link to="/login" className="text-gray-600 hover:text-orange-500 transition-colors">
              登录
            </Link>
            <Link to="/register">
              <Button size="sm">注册</Button>
            </Link>
            <Link to="/cart" className="relative p-2 text-gray-600 hover:text-orange-500 transition-colors">
              
            </Link>
          </div>
        </div>

        {/* Navigation Menu */}
        <nav className="border-t border-gray-100">
          <div className="flex items-center space-x-8 py-3">
            <Link to="/" className="text-gray-700 hover:text-orange-500 transition-colors">
              首页
            </Link>
            <div className="relative group">
              <button className="flex items-center text-gray-700 hover:text-orange-500 transition-colors">
                商品分类
                <i className="ri-arrow-down-s-line ml-1"></i>
              </button>
              <div className="absolute top-full left-0 mt-1 w-48 bg-white border border-gray-200 rounded-lg shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50">
                <Link to="/category/office" className="block px-4 py-2 text-sm text-gray-700 hover:bg-orange-50 hover:text-orange-500">
                  办公用品
                </Link>
                <Link to="/category/photography" className="block px-4 py-2 text-sm text-gray-700 hover:bg-orange-50 hover:text-orange-500">
                  摄影器材
                </Link>
                <Link to="/category/electronics" className="block px-4 py-2 text-sm text-gray-700 hover:bg-orange-50 hover:text-orange-500">
                  电子产品
                </Link>
              </div>
            </div>
            <Link to="/about" className="text-gray-700 hover:text-orange-500 transition-colors">
              关于我们
            </Link>
            <Link to="/merchant" className="text-gray-700 hover:text-orange-500 transition-colors">
              入驻流程
            </Link>
            <Link to="/news" className="text-gray-700 hover:text-orange-500 transition-colors">
              资讯
            </Link>
            <Link to="/contact" className="text-gray-700 hover:text-orange-500 transition-colors">
              联系我们
            </Link>
          </div>
        </nav>
      </div>
    </header>
  );
}
